// Dynamic login wall, core side (plans/dynamic-login-wall.md, Phase 3). The
// eager SDK only loads the wall bundle on an article page at least 7 days
// old, by its published time in the page contract or the Open Graph markup
// that RebelMouse and the CMS both render. The bundle (lib/loginWall/run.js)
// makes every other check and fails open. The core passes it the brand's
// section rules, so the bundle does not carry every brand config.
const BUNDLE_PATH = require('./bundlePath');
const { getBrandConfig } = require('../../brandConfigs');
const RULES = require('./config');
const { loadScript } = require('../scriptLoader');
const { isPrerendering, isSameSiteWithIssuer, isTopLevelContext } = require('../identity/context');

let installed = false;

// The verdict the article ads wait for (owner, 2026-10-29): a walled view
// never requests the units the wall hides. It settles once, so a wall can
// no longer show after the ads stop waiting.
let settled = false;
let settle;
const verdict = new Promise((resolve) => { settle = resolve; });

function decide(walled) {
  if (settled) return;
  settled = true;
  settle(walled === true);
}

function start({ api, brand, issuer, isArticle }) {
  if (!isArticle() || !isTopLevelContext() || !isSameSiteWithIssuer(issuer) || isPrerendering()) return decide(false);
  const preview = new URLSearchParams(window.location.search).get(RULES.PREVIEW_PARAM) === RULES.PREVIEW_VALUE;
  const published = Date.parse(window.millaPage?.publishedAt || document.querySelector('meta[property="article:published_time"]')?.getAttribute('content') || '');
  if (!preview && !(Date.now() - published >= RULES.MIN_AGE_DAYS * 86400000)) return decide(false);
  const origin = new URL(issuer).origin;
  const brandConfig = getBrandConfig(brand);
  const sections = {
    excluded: [brandConfig.staticPagesSectionId, ...(brandConfig.loginWall?.excludedSectionIds || [])].filter(Boolean),
    usa: getBrandConfig('narcity').usaSectionId
  };
  loadScript(`${origin}${BUNDLE_PATH}`)
    .then(() => window.MillaLoginWall.run({ api, brand, origin, preview, sections, mayWall: () => !settled }))
    .then(decide, () => decide(false));
}

/** Runs once per page after the DOM is ready. */
function setupLoginWall({ api, brand, issuer, isArticle }) {
  if (installed || typeof window === 'undefined' || typeof document === 'undefined') return;
  installed = true;
  const run = () => { try { start({ api, brand, issuer, isArticle }); } catch (_) { decide(false); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
}

/** Resolves true for a walled view; the ads wait at most RULES.ADS_WAIT_MS. */
function whenLoginWallDecided() {
  if (!installed) return Promise.resolve(false);
  if (!settled) setTimeout(() => decide(false), RULES.ADS_WAIT_MS);
  return verdict;
}

module.exports = { setupLoginWall, whenLoginWallDecided };
